import { computed } from '@vue/composition-api'
import { permissionChecker } from '@futureecom/futureecom-js/dist/helpers/auth/auth-helpers'
import { useAuth } from '@/composable/useAuth'
import { useStores } from '@/composable/repositories/useStores'

export const can = (scope: string[], org?: string, store?: string) => {
  const { currentStore } = useStores()
  const { accessToken } = useAuth()

  return computed((): boolean => {
    const { organisation_code, code } = currentStore.value || {}

    const organisationCode = org || organisation_code
    const storeCode = store || code

    return scope.every((s) => permissionChecker(accessToken.value, s, organisationCode, storeCode))
  })
}

export const canAny = (scope: string[], org?: string, store?: string) => {
  const { currentStore } = useStores()
  const { accessToken } = useAuth()

  return computed((): boolean => {
    const { organisation_code, code } = currentStore.value || {}

    const organisationCode = org || organisation_code
    const storeCode = store || code

    return scope.some((s) => permissionChecker(accessToken.value, s, organisationCode, storeCode))
  })
}
